import { mapGetters } from 'vuex'
import htmlHelper from '@/helpers/html'

export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'getterResultQuery'
    ])
  },
  methods: {
    downloadCsv () {
      let csv = this.$papa.unparse(this.getterResultQuery.result, {
        quotes: false,
        quoteChar: '"',
        escapeChar: '"',
        delimiter: ';',
        header: Object.keys(this.getterResultQuery.result[0]),
        newline: '\r\n',
        skipEmptyLines: false,
        columns: null
      })
      csv = '\uFEFF' + htmlHelper.decode(csv)
      this.$papa.download(csv, 'Resultado')
    }
  }
}
